const ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
const MODIFIER_KEYS = [
    'Shift',
    'ShiftLeft',
    'ShiftRight',
    'Control',
    'ControlLeft',
    'ControlRight',
    'Alt',
    'AltLeft',
    'AltRight',
    'Meta',
    'MetaLeft',
    'MetaRight',
];
const ARROW_KEY_SET = new Set(ARROW_KEYS);
const MODIFIER_KEY_SET = new Set(MODIFIER_KEYS);
function isArrowKey(key) {
    return ARROW_KEY_SET.has(key);
}
function isModifierKey(key) {
    return MODIFIER_KEY_SET.has(key);
}
function isPrintableKey(event) {
    // Printable characters are USUALLY length=1. Some are length=2 like emojis or math symbols,
    // but we don't need to handle those edge cases. Spacebar is treated as " ".
    if (event.key.length !== 1) {
        return false;
    }
    // Don't allow modifiers. Shift is okay for uppercase.
    if (event.ctrlKey || event.metaKey || event.altKey) {
        return false;
    }
    return true;
}
const makeMoveCheck = ({ universal, vertical, horizontal }) => (e, direction = 'vertical') => {
    if (universal(e))
        return true;
    if (direction === 'vertical')
        return vertical(e);
    if (direction === 'horizontal')
        return horizontal(e);
    return vertical(e) || horizontal(e);
};
const isMoveToBeginning = makeMoveCheck({
    universal: ({ key }) => key === 'Home',
    vertical: ({ key, altKey }) => key === 'ArrowUp' && altKey,
    horizontal: ({ key, altKey }) => key === 'ArrowLeft' && altKey,
});
const isMoveToEnd = makeMoveCheck({
    universal: ({ key }) => key === 'End',
    vertical: ({ key, altKey }) => key === 'ArrowDown' && altKey,
    horizontal: ({ key, altKey }) => key === 'ArrowRight' && altKey,
});
const isMoveNext = makeMoveCheck({
    universal: ({ key, ctrlKey }) => key === 'n' && ctrlKey,
    vertical: ({ key }) => key === 'ArrowDown',
    horizontal: ({ key }) => key === 'ArrowRight',
});
const isMovePrevious = makeMoveCheck({
    universal: ({ key, ctrlKey }) => key === 'p' && ctrlKey,
    vertical: ({ key }) => key === 'ArrowUp',
    horizontal: ({ key }) => key === 'ArrowLeft',
});

export { ARROW_KEYS, MODIFIER_KEYS, isArrowKey, isModifierKey, isMoveNext, isMovePrevious, isMoveToBeginning, isMoveToEnd, isPrintableKey };
//# sourceMappingURL=key-code.js.map
